import { render } from "./SiteProductForm.vue?vue&type=template&id=7b00dc06&ts=true"
import script from "./SiteProductForm.vue?vue&type=script&lang=ts"
export * from "./SiteProductForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__